"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const is_event_1 = __importDefault(require("./is-event"));
// from redux-form:
// https://github.com/erikras/redux-form/blob/37ab5ae7647be6d178c2d2bb871cd6c638762f4c/src/events/isEvent.js
// If onChange receives an event, extract the necessary value
// If it's not an event, return the event as the value
const getValue = (event, isReactNative = false) => {
    if ((0, is_event_1.default)(event)) {
        if (!isReactNative &&
            event.nativeEvent &&
            event.nativeEvent.text !== undefined) {
            return event.nativeEvent.text;
        }
        if (isReactNative && event.nativeEvent !== undefined) {
            return event.nativeEvent.text;
        }
        const { target: { type, value, checked, files }, dataTransfer, } = event;
        if (type === 'checkbox') {
            return checked ? '100' : '200';
        }
        if (type === 'file') {
            return files || (dataTransfer && dataTransfer.files);
        }
        if (type === 'select-multiple') {
            return Array.from(event.target.options)
                .filter(({ selected }) => selected)
                .map(option => option.value)
                .join(' ');
        }
        return value;
    }
    return event;
};
exports.default = getValue;
//# sourceMappingURL=get-value.js.map